import React, { useCallback, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { get, size } from "lodash";
import {
  Button,
  Grid,
  Typography,
  TextField,
  Stack,
  Divider,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import { useSnackbar } from "notistack";

import Iconify from "../../components/iconify/iconify";
// import CustomPopover, { usePopover } from "../../components/custom-popover";
import { Box } from "@mui/system";
import { useAreaForm } from "../../data/talons/Area/useAreaForm";
import { color } from "../../utils/constant";
import { useSelector } from "react-redux";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import CustomPopover from "../../components/custom-popover/custom-popover";
import usePopover from "../../components/custom-popover/use-popover";
import { useLabReportForm } from "../../data/talons/Appointment/useLabReportForm";
import { useAppointmentForm } from "../../data/talons/Appointment/useAppointmentForm";

/*
 * Render Real - Estate Inquiry Form screen
 *
 *
 */

export default function LabReportForm(props) {
  const { editItem, appTestId } = props;

  const popover = usePopover();
  const { enqueueSnackbar } = useSnackbar();

  const [imageData, setImageData] = useState(
    size(editItem?.report_url) == 0 ? null : editItem?.report_url
  );

  const {
    labTestReportEntry,
    labTestReportUpdate,
    handleFileChange,
    labReportEntrySchema,
  } = useLabReportForm({
    existingImageUrl: get(editItem, "report_url", ""),
    labtestId: appTestId,
  });

  const defaultValues = useMemo(() => ({
    remark: get(editItem, "remark", ""),
    reportName: get(editItem, "report_name", ""),
  }));

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
  } = useForm({
    resolver: joiResolver(labReportEntrySchema),
    defaultValues,
  });

  const onUserSubmit = useCallback(async () => {
    try {
      const res =
        get(editItem, "id", null) === null
          ? await labTestReportEntry({
              ...getValues(),
            })
          : await labTestReportUpdate({
              ...getValues(),
              id: get(editItem, "id", null),
            });
      if (res === true) {
        props.postSubmit();
      } else {
        enqueueSnackbar("Problem While Saving Report Data", {
          variant: "error",
        });
      }
    } catch (err) {
      console.log("errr", err);
    }
  }, [labTestReportEntry, labTestReportUpdate]);

  const fileUpload = (file) => {
    handleFileChange(file);
    popover.onClose();
    const reader = new FileReader();
    reader.onload = () => {
      setImageData(reader.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        Upload Report
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        {imageData === null ? (
          <Grid item xs={12} sm={12} mt={3}>
            <IconButton
              className="p-0"
              style={{ width: "100%", borderRadius: "0px" }}
              color="primary"
            >
              <label
                htmlFor="upload"
                onMouseEnter={(e) => (e.target.style.padding = "1rem")}
                style={{
                  width: "100%",
                  height: "210px",
                  border: "2px dashed #1976d2",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <>
                  <AddAPhotoIcon style={{ fontSize: "3rem" }} />
                  <input
                    onChange={(e) => fileUpload(e.target.files[0])}
                    type="file"
                    hidden={true}
                    id="upload"
                  />
                </>
              </label>
            </IconButton>
          </Grid>
        ) : (
          <Grid
            item
            xs={12}
            sm={12}
            sx={{ width: "100%", textAlign: "center" }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "end",
              }}
            >
              <IconButton className="iconbtn" onClick={popover.onOpen}>
                <Iconify icon="eva:more-vertical-fill" />
              </IconButton>
            </Box>
            {imageData.split(";")[0].split(":")[1].startsWith("image") ||
            ["jpeg", "jpg", "png", "webp"].includes(
              imageData.split(".").pop()
            ) ? (
              <img
                className="uploadedImg"
                src={imageData}
                style={{
                  marginBottom: "10px",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            ) : imageData
                .split(";")[0]
                .split(":")[1]
                .startsWith("application/pdf") ||
              ["pdf"].includes(imageData.split(".").pop()) ? (
              <embed
                src={imageData}
                type="application/pdf"
                width="100%"
                height="210px"
                style={{
                  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                  border: "1px dashed blue",
                  borderRadius: "10PX",
                }}
              />
            ) : imageData.split(";")[0].split(":")[1].startsWith("text") ||
              ["txt"].includes(imageData.split(".").pop()) ? (
              <iframe
                style={{
                  width: "95%",
                  height: "210px",
                  border: "1px dashed blue",
                  borderRadius: "10PX",
                  boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                }}
                src={imageData}
              ></iframe>
            ) : (
              <Typography variant="h6">
                File type not supported for preview
              </Typography>
            )}

            <CustomPopover
              open={popover.open}
              onClose={popover.onClose}
              arrow="right-top"
              sx={{ width: 100, ml: 1, marginTop: "30px" }}
            >
              <IconButton
                style={{
                  width: "100%",
                  borderRadius: "0px",
                  fontSize: "16px",
                  fontWeight: "normal",
                }}
                color="primary"
                sx={{ padding: 0 }}
              >
                <label
                  htmlFor="uploadagain"
                  style={{
                    width: "100%",
                    padding: 7,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      cursor: "pointer",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <Iconify icon="solar:pen-bold" />
                      <span style={{ marginLeft: "10px" }}>Edit</span>
                    </div>

                    <input
                      className="uploadInput"
                      // accept="image/*"
                      onChange={(e) => fileUpload(e.target.files[0])}
                      type="file"
                      hidden={true}
                      id="uploadagain"
                    />
                  </div>
                </label>
              </IconButton>
              <div
                onClick={() => setImageData(null)}
                style={{
                  display: "flex",
                  marginLeft: "5px",
                  alignItems: "center",
                  cursor: "pointer",
                  color: "red",
                }}
              >
                {/* <Iconify icon="solar:trash-bin-trash-bold" /> */}
                {/* <span style={{ marginLeft: "10px" }}>Delete</span> */}
              </div>
            </CustomPopover>
          </Grid>
        )}
        <Grid item xs={12} sm={11.7}>
          <TextField
            required
            sx={{ ml: 1 }}
            id="reportName"
            name="reportName"
            label="Report Name"
            fullWidth={true}
            variant="outlined"
            multiline
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("reportName")}
            autoComplete="false"
            error={size(errors?.reportName?.message) > 0}
            helperText={
              size(errors?.reportName?.message) > 0
                ? errors?.reportName?.message
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={11.7}>
          <TextField
            sx={{ marginBottom: "20px", ml: 1 }}
            id="remark"
            name="remark"
            label="Remark"
            fullWidth={true}
            variant="outlined"
            multiline
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            {...register("remark")}
            autoComplete="false"
          />
        </Grid>

        <Grid container direction="row">
          <Grid item xs={12} sm={12}>
            <Stack direction="row" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  backgroundColor: color.button,
                  "&:hover": {
                    backgroundColor: color.button,
                  },
                }}
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(onUserSubmit)();
                }}
              >
                Save
              </Button>
              <Button
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  borderColor: color.button,
                  color: color.button,
                  "&:hover": {
                    color: color.button,
                  },
                }}
                variant="outlined"
                onClick={(e) => {
                  e.preventDefault();
                  props.postSubmit();
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
